// =================================================================================================
// Mona Core API
// The version of the OpenAPI document: https://core.qa1.dev.cmona.de/auto-open-api-spec.yaml 1.9.0
// Contact: https://www.clinomic.biz
//
// NOTE: This class is auto generated at 2026-07-24T13:16:53.216391+03:00[Europe/Kiev]
// by OpenAPI Generator https://openapi-generator.tech
// Do not edit the class manually.
// =================================================================================================

import camelcaseKeys from 'camelcase-keys';
import { instanceToPlain, plainToInstance, Type, Transform } from 'class-transformer';
import snakecaseKeys, { SnakeCaseKeys } from 'snakecase-keys';
import { TransformDate } from '../helpers';
import { OriginalStandardMedicationSet } from './originalStandardMedicationSet';

/**
 * Serializer for PrescriptionSetMedicine Model Structure
 * @see #/components/schemas/MinimalPrescriptionSetMedication - reference to schema in open-api-spec.yaml
 * @since 2026-07-24T13:16:53.216391+03:00[Europe/Kiev]
 * @version 1.9.0
 *
 * NOTE: This class is auto generated by OpenAPI Generator
 * Do not edit this manually.
 */
export interface MinimalPrescriptionSetMedication {
    id: string;
    instructions: string;
    standard_medication_set: OriginalStandardMedicationSet;
}
// -----------------------------------------------------------------------------
// Frontend Model
// NOTE: This class is auto generated by OpenAPI Generator
// Do not edit the class manually.
// -----------------------------------------------------------------------------

/**
 * Namespace that holds Frontend models/classes for MinimalPrescriptionSetMedication
 */
export namespace MinimalPrescriptionSetMedication {
    /**
     * MinimalPrescriptionSetMedication Frontend Model with camelCase properties
     * @since 2026-07-24T13:16:53.216391+03:00[Europe/Kiev]
     * @version 1.9.0
     *
     * NOTE: This class is auto generated by OpenAPI Generator
     * Do not edit the class manually.
     */
    export class Model {
        id: string;
        instructions: string;
        @Type(() => OriginalStandardMedicationSet.Model) standardMedicationSet: OriginalStandardMedicationSet.Model;

        /** @hideconstructor */
        constructor(obj: Model) {
            Object.assign(this, camelcaseKeys(obj, { deep: true }));
        }
    }
    /**
     * MinimalPrescriptionSetMedication DTO
     * Transforms MinimalPrescriptionSetMedication model from/to API object
     * @since 2026-07-24T13:16:53.216391+03:00[Europe/Kiev]
     * @version 1.9.0
     *
     * NOTE: This class is auto generated by OpenAPI Generator
     * Do not edit the class manually.
     */
    export class DTO {
        /** Transforms to Frontend MinimalPrescriptionSetMedication model */
        static toModel(obj: MinimalPrescriptionSetMedication): Model {
            const newObj = camelcaseKeys(obj, { deep: true });
            return plainToInstance(Model, newObj);
        }
        /** Transforms to Backend MinimalPrescriptionSetMedication model */
        static toApi(obj: Model): MinimalPrescriptionSetMedication {
            const newObj = instanceToPlain(plainToInstance(Model, obj)) as MinimalPrescriptionSetMedication;
            return snakecaseKeys(newObj, { deep: true });
        }
    }
}
